module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-field"
  }, [_c('el-form', {
    ref: "fieldData",
    staticClass: "edit-field-form",
    attrs: {
      "model": _vm.fieldData,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "field_name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.fieldData.field_name),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "field_name", $$v)
      },
      expression: "fieldData.field_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Field Type",
      "prop": "type_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Field Type"
    },
    model: {
      value: (_vm.fieldData.type_id),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "type_id", $$v)
      },
      expression: "fieldData.type_id"
    }
  }, _vm._l((_vm.types), function(f_type) {
    return _c('el-option', {
      key: f_type.id,
      attrs: {
        "value": f_type.id,
        "label": f_type.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Light Type",
      "prop": "light_type_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Light Type"
    },
    model: {
      value: (_vm.fieldData.light_type_id),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "light_type_id", $$v)
      },
      expression: "fieldData.light_type_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "LED Switchbox",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "LED AAA-Lux",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Metal Halide",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Restrike Time",
      "prop": "min_off_time "
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.fieldData.min_off_time),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "min_off_time", $$v)
      },
      expression: "fieldData.min_off_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.devicesLoading),
      expression: "devicesLoading"
    }]
  }, [_c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Power Relay",
      "prop": "power_relay"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Power Relay"
    },
    model: {
      value: (_vm.fieldData.power_relay),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "power_relay", $$v)
      },
      expression: "fieldData.power_relay"
    }
  }, _vm._l((_vm.devices), function(device) {
    return _c('el-option', {
      key: device.id,
      attrs: {
        "label": device.name,
        "value": device.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.fieldData.power_relay > 0) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Logical"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Logical no"
    },
    model: {
      value: (_vm.fieldData.logical_no),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "logical_no", $$v)
      },
      expression: "fieldData.logical_no"
    }
  }, _vm._l((_vm.logicals), function(logical) {
    return _c('el-option', {
      key: logical.logical_no,
      attrs: {
        "label": logical.logical_no,
        "value": logical.logical_no
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Delay",
      "prop": "delay"
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.fieldData.delay),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "delay", $$v)
      },
      expression: "fieldData.delay"
    }
  }), _vm._v(" Seconds\n        ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "align": "left"
    },
    attrs: {
      "label": "Interface",
      "prop": "interface_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Interface"
    },
    model: {
      value: (_vm.fieldData.interface_id),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "interface_id", $$v)
      },
      expression: "fieldData.interface_id"
    }
  }, _vm._l((_vm.interfaces), function(inter) {
    return _c('el-option', {
      key: inter.id,
      attrs: {
        "label": inter.name,
        "value": inter.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldData.interface_id > 0),
      expression: "fieldData.interface_id > 0"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Lights"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "Enter new MAC or choose from list",
      "value-key": "mac"
    },
    on: {
      "change": _vm.macInputChanged
    },
    model: {
      value: (_vm.fieldData.lights),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "lights", $$v)
      },
      expression: "fieldData.lights"
    }
  }, _vm._l((_vm.lights), function(light) {
    return _c('el-option', {
      key: light.id,
      attrs: {
        "label": light.mac,
        "value": light
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submit('fieldData')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73eb5548","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Fields/EditField.vue
// module id = 1022
// module chunks = 9